import { render } from "./EventSchedule.vue?vue&type=template&id=f719e87e&ts=true"
import script from "./EventSchedule.vue?vue&type=script&lang=ts"
export * from "./EventSchedule.vue?vue&type=script&lang=ts"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__